export const OBTER_FUNCIONARIOS = 'GESTAO_PERIODO/OBTER_FUNCIONARIOS'

export const OBTER_FUNCIONARIOS_FILTRO = 'GESTAO_PERIODO/OBTER_FUNCIONARIOS_FILTRO'

export const OBTER_REFERENCIAS = 'GESTAO_PERIODO/OBTER_REFERENCIAS'

export const OBTER_ATIVIDADES = 'GESTAO_PERIODO/OBTER_ATIVIDADES'

export const OBTER_ATIVIDADES_DETALHES = 'GESTAO_PERIODO/OBTER_ATIVIDADES_DETALHES'

export const OBTER_ATIVIDADES_TIPO = 'GESTAO_PERIODO/OBTER_ATIVIDADES_TIPO'

export const INCLUIR_ATIVIDADE = 'GESTAO_PERIODO/INCLUIR_ATIVIDADE'

export const OBTER_PATIO = 'GESTAO_PERIODO/OBTER_PATIO'

export const OBTER_ESCALA = 'GESTAO_PERIODO/OBTER_ESCALA'

export const OBTER_ATIVIDADE_POR_ID = 'GESTAO_PERIODO/OBTER_ATIVIDADE_POR_ID'

export const EDITAR_ATIVIDADE = 'GESTAO_PERIODO/EDITAR_ATIVIDADE'

export const DESCONSIDERAR_ATIVIDADE = 'GESTAO_PERIODO/DESCONSIDERAR_ATIVIDADE'
